/**
 * Converts a file size in bytes into a human-readable string with an appropriate unit.
 *
 * @param {number} size - The file size in bytes.
 * @returns {string} The formatted size string (e.g., "1.23 MB").
 */
export function humanFileSize(size) {
    const i = size == 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
    return Number((size / Math.pow(1024, i)).toFixed(2)) + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
}
